module.exports = __webpack_public_path__ + "img/1957.a9428759.png";